import { Box } from '@chakra-ui/react'
import { lazy, Suspense } from 'react'

import { AuthButton } from 'components/auth/AuthButton'
import { LoadingSpinner } from 'components/shared/LoadingSpinner'
import { useAuth } from 'contexts/AuthContext'

import type { ComparisonScreen } from 'modules/comparison/screens/ComparisonScreen'

const Comparison = lazy(() =>
  import(/* webpackChunkName: "comparison" */ 'modules/comparison/screens/ComparisonScreen').then(
    (module: { ComparisonScreen: typeof ComparisonScreen }) => ({
      default: module.ComparisonScreen,
    })
  )
)

export const ComparisonPage = () => {
  /* --- Section 1: Hooks --- */
  const { user, loading } = useAuth()
  /* --- Section 5: Early Returns --- */
  if (loading) {
    return <LoadingSpinner />
  }
  if (!user) {
    return (
      <Box as="main" margin="auto" padding={8} maxWidth="560px">
        <h1>See your free throw, side by side</h1>
        <p>Sign in to Pocket Coach to upload your video and compare each phase.</p>
        <AuthButton />
      </Box>
    )
  }
  /* --- Section 6: Render --- */
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <Comparison key={user.id} />
    </Suspense>
  )
}
